import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const AULARIO_CONST = 'aulario';
export const aularioApi = `${baseUrl}/${AULARIO_CONST}`;

export const allAularioService = async (params) => {
  const res = await axios.get(aularioApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveAularioService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${aularioApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(aularioApi, data, { headers: token({}) });
  }
  return res;
};

export const oneAularioService = async (id) => {
  const res = await axios.get(`${aularioApi}/${id}`, { headers: token({}) });
  return res;
};

export const deleteAularioService = async (id) => {
  const res = await axios.delete(`${aularioApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
